import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { confirmBooking, listBookings, releaseBooking } from "../lib/api";
import { toast } from "sonner";
import { formatBookingDateEs } from "../lib/format";

const statusLabel = {
  pendiente: "Pendiente",
  pagada_por_confirmar: "Pagada por confirmar",
  pagada: "Pagada",
  cancelada: "Cancelada",
};

export default function PanelPage() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadBookings = useCallback(() => {
    setLoading(true);
    listBookings()
      .then(setBookings)
      .catch(() => toast.error("No se han podido cargar las reservas."))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    loadBookings();
  }, [loadBookings]);

  const updateBooking = async (id, action) => {
    try {
      if (action === "confirm") {
        await confirmBooking(id);
        toast.success("Pago confirmado.");
      } else {
        await releaseBooking(id);
        toast.success("Hueco liberado.");
      }
      loadBookings();
    } catch (error) {
      toast.error(error.response?.data?.detail || "No se ha podido actualizar la reserva.");
    }
  };

  return (
    <main className="max-w-[1280px] mx-auto px-6 lg:px-10 py-16 lg:py-20">
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div>
          <div className="wk-eyebrow mb-4">Panel</div>
          <h1 className="text-[42px] lg:text-[56px] font-extrabold tracking-hero leading-[1.05]" style={{ color: "#1E1924" }} data-testid="panel-title">
            Reservas
          </h1>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link className="wk-btn wk-btn-ghost" to="/panel/tutores" data-testid="panel-tutors-link">
            Gestionar tutores
          </Link>
          <Link className="wk-btn wk-btn-ghost" to="/panel/contactos" data-testid="panel-contacts-link">
            Ver contactos
          </Link>
        </div>
      </div>

      {loading ? <div className="wk-skel mt-10" style={{ height: 180 }} /> : null}
      {!loading && bookings.length === 0 ? (
        <div className="wk-card mt-10 p-10" data-testid="panel-empty-bookings">
          Aún no hay reservas.
        </div>
      ) : null}
      {!loading && bookings.length > 0 ? (
        <div className="mt-10 space-y-3" data-testid="panel-bookings-list">
          {bookings.map((booking) => {
            const mutable = booking.status === "pendiente" || booking.status === "pagada_por_confirmar";
            return (
              <article key={booking.id} className="wk-card p-5 flex flex-wrap gap-5 items-center" data-testid={`panel-booking-${booking.id}`}>
                <div className="flex-1 min-w-[220px]">
                  <div className="font-semibold text-[17px]" style={{ color: "#1E1924" }}>
                    {booking.student_name} · {booking.tutor_display_name}
                  </div>
                  <p className="mt-1 text-[13px]" style={{ color: "#70667A" }}>
                    {booking.student_email} · {formatBookingDateEs(booking.booking_date)} · {booking.booking_time} · Pack Prueba de Pronunciación · $22
                  </p>
                </div>
                <span className="wk-chip wk-chip-accent" data-testid={`panel-booking-status-${booking.id}`}>
                  {statusLabel[booking.status] || booking.status}
                </span>
                <div className="flex flex-wrap gap-2">
                  <button
                    className="wk-btn wk-btn-primary"
                    disabled={!mutable}
                    onClick={() => updateBooking(booking.id, "confirm")}
                    data-testid={`panel-confirm-payment-${booking.id}`}
                  >
                    Confirmar pago
                  </button>
                  <button
                    className="wk-btn wk-btn-ghost"
                    disabled={!mutable}
                    onClick={() => updateBooking(booking.id, "release")}
                    data-testid={`panel-release-slot-${booking.id}`}
                  >
                    Liberar hueco
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      ) : null}
    </main>
  );
}